import { render, staticRenderFns } from "./transports.vue?vue&type=template&id=2a041a66"
import script from "./transports.vue?vue&type=script&lang=js"
export * from "./transports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports